import "./App.css";
import Aboutme from "./components/About/Aboutme";
import Contact from "./components/Conatct/Contact";
import GitStats from "./components/GitStats/GitStats";
import Hero from "./components/Hero/Hero";
import Navbar from "./components/Navbar/Navbar";
import Projects from "./components/Projects/Projects";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import Skills from "./components/Skills/Skills";

function App() {
  return (
    <div className="App">
      <ScrollToTop />
      <div>
        <Navbar />
      </div>
      <div id="home">
        <br />
        <Hero />
      </div>
      <div id="about">
        <br />
        <Aboutme />
      </div>
      <div id="skills">
        <br />
        <Skills />
      </div>
      <GitStats />
      <div id="projects">
        <br />
        <Projects />
      </div>
      <div id="contact">
        <br />
        <Contact />
      </div>
    </div>
  );
}

export default App;
